export const cropsTranslationsRo = {
  'crops.58.pheno_stage.stade_1': 'Răsărire',
  'crops.58.pheno_stage.stade_2': '1 frunză',
  'crops.58.pheno_stage.stade_3': '2 frunze',
  'crops.58.pheno_stage.stade_4': '4 frunze',
  'crops.58.pheno_stage.stade_5': '6 frunze',
  'crops.58.pheno_stage.stade_6': '7 frunze',
  'crops.58.pheno_stage.stade_7': '8 frunze',
  'crops.58.pheno_stage.stade_8': '10 frunze',
  'crops.58.pheno_stage.stade_f': 'Înflorire',
  'crops.58.pheno_stage.stade_9': '32% SM',
  'crops.58.pheno_stage.stade_10': 'Maturitate',
  'crops.59.pheno_stage.stade_1': 'Răsărire',
  'crops.59.pheno_stage.stade_2': '1 frunză',
  'crops.59.pheno_stage.stade_3': '2 frunze',
  'crops.59.pheno_stage.stade_4': '4 frunze',
  'crops.59.pheno_stage.stade_5': '6 frunze',
  'crops.59.pheno_stage.stade_6': '7 frunze',
  'crops.59.pheno_stage.stade_7': '8 frunze',
  'crops.59.pheno_stage.stade_8': '10 frunze',
  'crops.59.pheno_stage.stade_f': 'Înflorire',
  'crops.59.pheno_stage.stade_9': '32% SM',
  'crops.59.pheno_stage.stade_10': 'Maturitate',
  'crops.60.pheno_stage.stade_1': 'Răsărire',
  'crops.60.pheno_stage.stade_2': '1 frunză',
  'crops.60.pheno_stage.stade_3': '2 frunze',
  'crops.60.pheno_stage.stade_4': '4 frunze',
  'crops.60.pheno_stage.stade_5': '6 frunze',
  'crops.60.pheno_stage.stade_6': '7 frunze',
  'crops.60.pheno_stage.stade_7': '8 frunze',
  'crops.60.pheno_stage.stade_8': '10 frunze',
  'crops.60.pheno_stage.stade_f': 'Înflorire',
  'crops.60.pheno_stage.stade_9': '32% SM',
  'crops.60.pheno_stage.stade_10': 'Maturitate',
  'crops.102.pheno_stage.stade_1': 'Răsărire',
  'crops.102.pheno_stage.stade_2': '1 frunză',
  'crops.102.pheno_stage.stade_3': '2 frunze',
  'crops.102.pheno_stage.stade_4': '4 frunze',
  'crops.102.pheno_stage.stade_5': '6 frunze',
  'crops.102.pheno_stage.stade_6': '7 frunze',
  'crops.102.pheno_stage.stade_7': '8 frunze',
  'crops.102.pheno_stage.stade_8': '10 frunze',
  'crops.102.pheno_stage.stade_f': 'Înflorire',
  'crops.102.pheno_stage.stade_9': '32% SM',
  'crops.102.pheno_stage.stade_10': 'Maturitate',
  'crops.rapeseed.label': 'Rapiță',
  'crops.barley.label': 'Orz',
  'crops.soybean.label': 'Fasole',
  'crops.carotte.label': 'Morcov',
};
